import { LearningContentText } from '@quebon/shared-learning/components/common/LearningContentText'

interface Props {
  text: string | null | undefined
  emptyLabel?: string
  className?: string
  stripPointPrefix?: boolean
}

const SHORT_POINT_PREFIX_PATTERN = /^[ \t]*포인트[ \t]*[:：][ \t]*/

export function WarmupTextView({
  text,
  emptyLabel = '없음',
  className,
  stripPointPrefix = false,
}: Props) {
  const displayText = stripPointPrefix ? text?.replace(SHORT_POINT_PREFIX_PATTERN, '') : text

  if (!displayText) {
    return <span className="italic text-slate-400">{emptyLabel}</span>
  }
  return (
    <p className={className ?? 'text-sm leading-relaxed text-slate-700'}>
      <LearningContentText text={displayText} />
    </p>
  )
}
